<template>
  <CstuModal
    id="update-style-modal"
    title="Update Style"
    content-class="w-[650px]"
    dialog-class="!max-w-[650px]"
    body-class="no-scrollbar"
    scrollable
    size="lg"
    hide-footer
    centered
    radius='xl'
    no-close-on-backdrop
    @shown="handleModalShown"
  >
    <div>
      <CustomTab mode="style" />

      <!-- Footer -->
      <div class="flex items-center justify-end gap-3 px-2 pt-4">
        <Button
          variant="light" color="light" size="sm"
          @click="handleClose"
        >
          Cancel
        </Button>
        <Button
          size="sm"
          :loading="isLoading"
          @click="handleUpdateStyle"
        >
          Update
        </Button>
      </div>
    </div>
  </CstuModal>
</template>

<script setup>
import { inject, ref, onMounted, onBeforeUnmount, provide } from 'vue'
import { Button } from '@contentstudio/ui'
import CustomTab from '@modules/publisher/ai-content-library/components/form/tabs/CustomTab.vue'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import { useBrandInfoSetting } from '@modules/publisher/ai-content-library/composables/useBrandInfoSetting'

const { isLoading } = useSetup()
const { updateStyle } = useBrandInfoSetting()

const root = inject('root')
const { $cstuModal } = root

// Create an AbortController reference
const abortController = ref(null)

// Provide the abortController to child components
provide('abortController', abortController)

// Create a new AbortController when the component is mounted
onMounted(() => {
  abortController.value = new AbortController()
})

// Reset and create a new AbortController when the modal is shown
const handleModalShown = () => {
  // Create a new AbortController for this modal session
  abortController.value = new AbortController()
}

// Abort any pending requests when the component is unmounted
onBeforeUnmount(() => {
  if (abortController.value) {
    abortController.value.abort()
  }
})

const handleUpdateStyle = async () => {
  const result = await updateStyle()
  if (result) {
    $cstuModal.hide('update-style-modal')
  }
}

const handleClose = () => {
  // Abort any pending requests when the modal is closed
  if (abortController.value) {
    abortController.value.abort('User closed the modal')
    // Set to null to ensure garbage collection
    abortController.value = null
  }
  $cstuModal.hide('update-style-modal')
}
</script>
